<div class="horarios horarioWeb">
  <div class="container">
    <div class="row noBorderRow">
      <div class="col-3 SucursalItem">
        <div class="iconSucursal">
          <i class="bi bi-geo-alt-fill"></i>
        </div>
        <div (click)="mostrarModal()" data-bs-toggle="modal" data-bs-target="#modalSucursalSelect"
             class="nameSucursal d-flex  flex-row align-items-center " style="cursor:pointer;;">

          <p>{{ sucursalActual }} </p>
          <i style="color: var(--primary-color)" class=" mx-1 bi bi-caret-down-fill"></i>

        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row noBorderRow">
      <div class="col-3 SucursalItem">
        <div class="iconSucursal">
          <i class="bi bi-clock"></i>
        </div>
        <div class="nameHorarios">
          <p>Lun-Vier</p>
          <p>{{ horarioEsActual }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row ">
      <div class="col-3 SucursalItem">
        <div class="iconSucursal">
          <i class="bi bi-clock"></i>
        </div>
        <div class="nameHorarios">
          <p>Sábados</p>
          <p>{{ horarioSabadoActual }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row ">
      <div class="col-3 SucursalItem">
        <div class="iconSucursal">
          <i class="bi bi-clock"></i>
        </div>
        <div class="nameHorarios">
          <p>Domingos</p>
          <p>{{ horarioDomingoActual }}</p>
        </div>
      </div>
    </div>
  </div>
</div>


<div #modalSucursalSelect class="modal fade   p-4 py-md-5" tabindex="-1" role="dialog" id="modalSucursalSelect">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-4 shadow">
      <div class="modal-body ">

        <ul class="list-group">
          <li style="cursor: pointer;" *ngFor="let item of sucursales" class="list-group-item" aria-current="true" (click)="updateSucursalHorario(item)">
            <span class="fw-bold">{{item.nameSucursal}}</span>
            <br>
            <span class="fw-light">{{item.direccionSucursal}}</span>
          </li>

        </ul>

      </div>
    </div>
  </div>
</div>




